"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Table___StyledSvg",
  componentId: "sc-1s8zqb7-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function Table(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8 3.5c.663 0 1.2.546 1.2 1.219V15.28a1.21 1.21 0 01-1.2 1.219H3.2A1.21 1.21 0 012 15.281V4.72A1.21 1.21 0 013.2 3.5h13.6zM3.2 15.281h3.736v-2.3H3.2v2.3zm4.932 0h3.736v-2.3H8.132v2.3zm4.932 0H16.8v-2.3h-3.736v2.3zM3.2 11.76h3.736v-2.3H3.2v2.3zm4.932 0h3.736v-2.3H8.132v2.3zm4.932 0H16.8v-2.3h-3.736v2.3zM3.2 8.237h3.736v-2.3H3.2v2.3zm4.932 0h3.736v-2.3H8.132v2.3zm4.932 0H16.8v-2.3h-3.736v2.3z",
    fill: "currentColor"
  }));
}

var _default = Table;
exports["default"] = _default;